import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/database';

const firebaseConfig = {
  apiKey: "AIzaSyBD97ZpfpM-6imxxtkxEsvy-vOfulUn2eM",
  authDomain: "worldhappen-206b8.firebaseapp.com",
  databaseURL: "https://worldhappen-206b8-default-rtdb.asia-southeast1.firebasedatabase.app"
  /* These 5 lines do not seem to be necessary ???
  projectId: "worldhappen-206b8",
  storageBucket: "worldhappen-206b8.appspot.com",
  messagingSenderId: "509918560585",
  appId: "1:509918560585:web:17427e4fd040076a5b5a98",
  measurementId: "G-ZSTE34WRND" */
};

// Initialize Firebase
// const app = initializeApp(firebaseConfig); (MB commented out  and replaced by the line below)
firebase.initializeApp(firebaseConfig);
// const analytics = getAnalytics(app); (MB commented out temporarily at least)

// export default app; (MB commented out  and replaced by the line below)
export default firebase;
